module.exports = __webpack_public_path__ + "img/62.9907640c.png";